module.exports = __webpack_public_path__ + "assets/img/icon2.a1944252.svg";